// @flow
import React from 'react'
import './styles.scss'
// https://reactjsexample.com/a-very-simple-echarts-wrapper-for-react/
import ReactEcharts from 'echarts-for-react'
import echarts from 'echarts'

const thisYear = new Date().getFullYear()

const monthNames = [
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember'
]

export class MonthlyAnomaly extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800,
      displayData: {},
      chartOptions: {},
      echartInstance: null
    }
    this.handleEvents = {
      mouseover: this.onChartHover,
      mouseout: this.onChartLeave
    }
  }

  onChartHover = params => {
    // console.log('+++++ params ++++')
    // console.log(params)

    // highlight the hovered series
    this.state.echartInstance.setOption(this.getOption(params.seriesIndex))
  }

  onChartLeave = params => {
    // console.log('+++++ params ++++')
    // console.log(params)
    if (params.color === this.props.lineColors.highlight) {
      this.state.echartInstance.setOption(this.getOption(-1))
    }
  }

  componentDidMount() {
    // prepare Data according to set lastMonth
    const lastMonth = this.props.lastMonth.replace('-', '').toString()
    let displayData = this.props.data
    const monthIndex = this.props.data.findIndex(x => x.Month === lastMonth)
    if (monthIndex >= 0) {
      displayData = this.props.data.slice(0, monthIndex + 1)
    }
    this.setState({ displayData: displayData }, () => {
      this.setState(
        {
          chartOptions: this.getOption(-1)
        },
        () => {
          this.setState({
            echartInstance: this.echarts_react.getEchartsInstance()
          })
        }
      )
    })
  }

  getAllAnomalies(data) {
    // console.log('data', data)
    // console.log('highlightIndex', highlightIndex)

    const seriesData = []

    const AllAnomalies = data.map(function(currMonth, index) {
      // console.log('currMonth', currMonth)
      // return data for month
      return currMonth.global
    })

    // console.log('AllAnomalies:', AllAnomalies)

    // add markline at 0

    // console.log('AllAnomalies')
    // console.log(AllAnomalies)
    // return AllAnomalies
    seriesData.push({
      name: 'Monatliche Abweichung',
      type: 'line',
      color: this.props.lineColors.past,
      lineStyle: {
        width: 0.5,
        opacity: 0.8
      },
      showSymbol: false,
      symbolSize: 6,
      itemStyle: {
        borderWidth: 2,
        opacity: 1
      },
      connectNulls: true,
      silent: false,
      animation: false,
      data: AllAnomalies,
      z: 99,
      markPoint: {
        silent: true,
        data: [
          {
            name: 'aktuell',
            symbol: 'circle',
            symbolSize: 5,
            /* value: AllAnomalies[AllAnomalies.length - 1], */
            xAxis: 'max',
            yAxis: AllAnomalies[AllAnomalies.length - 1],
            itemStyle: {
              color: this.props.lineColors.past,
              borderColor: this.props.lineColors.current,
              borderWidth: 2
            },
            label: {
              color: '#ffffff',
              fontSize: 14,
              offset: [-25, 0]
            }
          }
        ]
      }
    })

    // add markline at 0
    const baseline = {
      name: 'baseline',
      type: 'line',
      color: '#FFFFFF',
      data: [0],
      silent: true,
      z: 2,
      markLine: {
        data: [
          {
            name: 'baseline',
            yAxis: 0
          }
        ],
        lineStyle: {
          type: 'solid'
        },
        symbol: false,
        symbolSize: 0,
        animation: false
      }
    }
    seriesData.push(baseline)

    // add month marks at the bottom
    const allMonths = this.getAllMonths(this.state.displayData)
    const monthMarks = {
      name: 'monthMarks',
      type: 'line',
      color: '#8e8e8e',
      data: [0],
      silent: true,
      z: 1,
      markLine: {
        data: [
          {
            name: '190001',
            xAxis: allMonths.indexOf('190001')
          },
          {
            name: '193001',
            xAxis: allMonths.indexOf('193001')
          },
          {
            name: '196001',
            xAxis: allMonths.indexOf('196001')
          },
          {
            name: '199001',
            xAxis: allMonths.indexOf('199001')
          },
          {
            name: '202001',
            xAxis: allMonths.indexOf('202001')
          }
        ],
        lineStyle: {
          type: 'dotted',
          opacity: 0.3
        },
        label: {
          show: false
        },
        symbol: false,
        symbolSize: 0,
        animation: false
      }
    }
    seriesData.push(monthMarks)

    return seriesData
  }

  getAllMonths(data) {
    const AllMonths = data.map(function(currMonth, index) {
      // console.log('currMonth', currMonth.Month)
      return currMonth.Month
    })

    // console.log('AllMonths', AllMonths)
    return AllMonths
  }

  // Chart Options
  // https://ecomfe.github.io/echarts-doc/public/en/option.html#title
  getOption = () => ({
    title: {
      text: '',
      subtext: ''
    },
    tooltip: {
      axisPointer: {
        snap: true,
        type: 'line'
      },
      trigger: 'axis',
      textStyle: {
        color: '#333'
      },
      backgroundColor: '#f3f3f3',
      formatter: function(params, ticket, callback) {
        // console.log('#### params ####', params)
        // console.log('#### data ####', this.state.displayData)
        const currMonthIndex = parseInt(params[0].axisValue.slice(-2)) - 1
        const currMonth = monthNames[currMonthIndex]
        const currYear = params[0].axisValue.substring(0, 4)
        const currTemp = parseFloat(params[0].data)
        const outputTemp =
          currTemp < 0 ? currTemp.toFixed(2) : '+' + currTemp.toFixed(2)
        const title =
          '<div class="tip-title"><strong>' +
          currMonth +
          '</strong> | ' +
          currYear +
          '</div>'
        let tooltipContent = title + '<hr class="under" />'
        tooltipContent += '<div class="row">'
        tooltipContent += 'Abweichung: '
        tooltipContent +=
          '<span class="weighted">' + outputTemp + ' °C</span></div>'
        // callback(console.log('scrubbed to: ', params[0].dataIndex))

        return tooltipContent
      }
    },
    grid: [
      {
        top: this.state.isMobile ? '5%' : '5%',
        left: 4,
        right: 12,
        bottom: 10,
        containLabel: true
      }
    ],
    xAxis: {
      type: 'category',
      boundaryGap: false,
      z: 2,
      data: this.getAllMonths(this.state.displayData),
      axisLine: {
        lineStyle: {
          color: ['#fff']
        }
      },
      axisLabel: {
        textStyle: {
          color: '#fff'
        },
        interval: 0,
        formatter: function(value, index, callback) {
          const cleanYear = value.substring(0, 4) // get year withouth month
          return value.slice(-6) === '190001' ||
            value.slice(-6) === '193001' ||
            value.slice(-6) === '196001' ||
            value.slice(-6) === '199001' ||
            value.slice(-6) === '202001'
            ? cleanYear
            : '' // check if its Jan. of a years to label
        }
      },
      axisTick: {
        show: false
      }
    },
    yAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: ['#727272']
        },
        show: false
      },
      axisTick: {
        length: 10000,
        inside: true
      },
      axisLabel: {
        formatter: '{value} °C',
        textStyle: {
          color: '#fff'
        }
      }
    },
    series: this.getAllAnomalies(this.state.displayData)
  })

  render() {
    // console.log('### DATA ###', this.state.displayData)
    // register theme object
    // theme object format example: https://github.com/apache/incubator-echarts/blob/master/theme/dark.js
    echarts.registerTheme('ta_theme', {
      backgroundColor: 'transparent',
      textStyle: {
        fontSize: '16',
        fontFamily:
          'TamediaChart,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif',
        color: '#333'
      },
      title: {
        textStyle: {
          color: '#333',
          fontSize: '22'
        },
        subtextStyle: {
          color: '#5f5f5f',
          fontSize: '18'
        }
      },
      legend: {
        left: 'left',
        orient: 'vertical',
        itemGap: 7,
        padding: [0, 0, 0, 10],
        itemWidth: 10,
        textStyle: {
          fontSize: '16'
        },
        show: false
      },
      label: {
        show: false
      },
      smooth: true
    })

    return (
      <div className='echart monthly-anomaly'>
        <h3>{this.props.title}</h3>
        <h5>{this.props.subtitle}</h5>
        <ReactEcharts
          ref={e => {
            this.echarts_react = e
          }}
          onEvents={this.handleEvents}
          option={this.state.chartOptions}
          opts={{ renderer: 'canvas' }}
          notMerge
          lazyUpdate
          theme='ta_theme'
          style={{ height: this.state.isMobile ? '20em' : '23em' }}
        />
        <div className='source'>
          Quelle:{' '}
          {/* }
          <Link href='https://www.meteoschweiz.admin.ch/home/klima/schweizer-klima-im-detail/homogene-messreihen-ab-1864.html?region=Tabelle'>
            Meteoschweiz
          </Link>
        */}
          NOAA
        </div>
      </div>
    )
  }
}
